import React, { createContext, useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

// Create context
const TokenContext = createContext();

export const TokenProvider = ({ children }) => {
  const [isValidToken, setIsValidToken] = useState(false);
  const [isCheckingToken, setIsCheckingToken] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  // Function to check if token is valid
  const validateToken = () => {
    const token = localStorage.getItem("authToken");

    // If no token exists, simply mark as not valid but don't trigger redirects
    if (!token) {
      setIsValidToken(false);
      setIsCheckingToken(false);
      return false;
    }

    try {
      // Decode token to get expiration
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      // Check if token has expired
      if (decodedToken.exp < currentTime) {
        // Token exists but is malformed - remove it
        localStorage.removeItem("authToken");
        setIsValidToken(false);
        setIsCheckingToken(false);

        navigate("/Signin-Signup");

        return false;
      }

      // Token is valid
      setIsValidToken(true);
      setIsCheckingToken(false);
      return true;
    } catch (error) {

      // Token exists but is invalid - remove it
      localStorage.removeItem("authToken");
      setIsValidToken(false);
      setIsCheckingToken(false);

      navigate("/Signin-Signup");

      return false;
    }
  };

  // Check token validity on component mount and periodically
  useEffect(() => {
    validateToken(); // Initial check

    const interval = setInterval(() => {
      validateToken();
    }, 60000); // Check every 60 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  // No automatic redirect logic here - we handle redirects only when a token exists
  // and is found to be invalid during validation

  return (
    <TokenContext.Provider
      value={{
        isValidToken,
        isCheckingToken,
        validateToken,
      }}
    >
      {children}
    </TokenContext.Provider>
  );
};

// Custom hook to use the token context
export const useToken = () => {
  const context = useContext(TokenContext);
  if (!context) {
    throw new Error("useToken must be used within a TokenProvider");
  }
  return context;
};
